import type { ReactElement } from 'react'

import type { MockedResponse } from '@apollo/client/testing'
import { LocalizationProvider } from '@mui/x-date-pickers-pro'
import { AdapterDateFns } from '@mui/x-date-pickers-pro/AdapterDateFns'
import { enGB } from 'date-fns/locale'
import { IntlProvider } from 'react-intl'

import { Alert, muiTheme, ThemeProvider } from '@acre/design-system'
import { render } from '@acre/test'
import type { Flags } from '@acre/utils'
import {
  applyScoreBranding,
  ErrorProvider,
  FlagProvider,
  flagsAllEnabled,
  flattenMessages,
  getMessages,
  Locales,
} from '@acre/utils'

import messages from '../../intl/messagesBrokerCrm'
import MockedProvider from './MockedProvider'

const flattenedMessages = flattenMessages(getMessages(messages, Locales.GB))

export default (tree: ReactElement, mocks?: MockedResponse<Record<string, any>>[], flags?: Flags) => {
  const children = mocks ? <MockedProvider mocks={mocks}>{tree}</MockedProvider> : tree
  const resolvedFlags = flags || flagsAllEnabled
  const providerMessages = resolvedFlags.feature?.score_rebrand
    ? applyScoreBranding(flattenedMessages)
    : flattenedMessages

  return render(
    <FlagProvider value={resolvedFlags}>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enGB}>
        <IntlProvider locale={Locales.GB} messages={providerMessages}>
          <ThemeProvider theme={muiTheme}>
            <ErrorProvider alertSlot={Alert} alertId="testErrorToast">
              {children}
            </ErrorProvider>
          </ThemeProvider>
        </IntlProvider>
      </LocalizationProvider>
    </FlagProvider>,
  )
}
